/**
 * Labstep
 *
 * @module components/Table/Action/Create
 * @desc Fields for table item
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules from 'labstep-web/services/validation/rules';

export const fieldTableName: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'name',
  placeholder: 'Add name',
  validation: rules.table.name,
};
